import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import {
  NavMenuItem,
  NavMenuItemType,
  NavMenuSection,
  NAV_MENU_ITEM,
} from '@shared/metadata/INavMenuItem';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';
import { OperationCode } from '@core/enum';
import { of } from 'rxjs';

const indexShellDisplay: IShellDisplay = {
  route: '/pages/contacts',
  navTitleKey: l10n('CONTACTS.INDEX.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:single-neutral-phone-book',
};
const createShellDisplay: IShellDisplay = {
  route: '/pages/contacts/new',
  navTitleKey: l10n('CONTACTS.CREATE.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:single-neutral-phone-book',
  hideNavBar$: of(true),
};
const editShellDisplay: IShellDisplay = {
  route: '/pages/contacts/edit',
  navTitleKey: l10n('CONTACTS.EDIT.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:single-neutral-phone-book',
  hideNavBar$: of(true),
};

const navMenuItem: NavMenuItem = {
  type: NavMenuItemType.SingleItem,
  route: '/pages/contacts',
  section: NavMenuSection.Account,
  titleKey: l10n('CONTACTS.INDEX.NAV_TITLE'),
  svgIcon: 'streamline:single-neutral-phone-book',
  operationCode: OperationCode.AccessReadContacts,
  order: 100,
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: SHELL_DISPLAY, useValue: indexShellDisplay, multi: true },
    { provide: SHELL_DISPLAY, useValue: createShellDisplay, multi: true },
    { provide: SHELL_DISPLAY, useValue: editShellDisplay, multi: true },
    { provide: NAV_MENU_ITEM, useValue: navMenuItem, multi: true },
  ],
})
export class ContactsMetadataModule {}
